import moment from 'moment';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { InputText } from 'primereact/inputtext';
import { Sidebar } from 'primereact/sidebar';
import { useEffect, useState } from 'react';
import FormInput from '../../../../components/Form/FormInput';
import { validateURL } from '../../../../utils/stringHelper';

function NewsPanel({ news, loading, isOpen, onCreate, onUpdate, onClose }) {
  const [title, setTitle] = useState('');
  const [sourceUrl, setSourceUrl] = useState(undefined);
  const [sourceLabel, setSourceLabel] = useState(undefined);
  const [author, setAuthor] = useState('');
  const [publicationDate, setPublicationDate] = useState('');

  useEffect(() => {
    if (news) {
      setTitle(news.title);
      setSourceUrl(news.source_url);
      setSourceLabel(news.source_label);
      setAuthor(news.author);
      setPublicationDate(new Date(news.publication_date));
    } else {
      setTitle('');
      setSourceUrl(undefined);
      setSourceLabel('');
      setAuthor('');
      setPublicationDate(new Date());
    }
  }, [news, isOpen]);

  const onValidate = () => {
    const newsPayload = {
      title,
      publication_date: moment(publicationDate).format('YYYY-MM-DD'),
      source_url: sourceUrl,
      source_label: sourceLabel,
      author
    };
    news ? onUpdate(newsPayload) : onCreate(newsPayload);
  };

  const formIsValid =
    title.length > 3 && publicationDate && sourceLabel.length > 3 && validateURL(sourceUrl);

  const footerButtons = (
    <div className="manage-footer">
      <Button
        key={'validate'}
        label={`Valider l'article`}
        loading={loading}
        disabled={!formIsValid}
        onClick={onValidate}
        severity="success"
      />
    </div>
  );

  return (
    <Sidebar
      style={{ width: 600 }}
      header={
        <h2 style={{ marginBottom: 0 }} className="text-slate-900 text-2xl font-medium">
          {`${news ? 'Modifier' : 'Ajouter'} un article`}
        </h2>
      }
      visible={isOpen}
      maskStyle={{ backgroundColor: '#00000080' }}
      onHide={onClose}
      position="right">
      <div className="sidebar-content-container">
        <div className="form-wrapper">
          <FormInput label={"Titre de l'article"} required isValid={title.length > 3}>
            <InputText
              id="title"
              value={title}
              placeholder="Mélisme(s) enflamme le Bout du monde 2025 !"
              onChange={(e) => setTitle(e.target.value)}
            />
          </FormInput>
          <FormInput label={'Nom du journal'} required isValid={sourceLabel}>
            <InputText
              id="source_label"
              value={sourceLabel}
              placeholder="Ouest-France"
              onChange={(e) => setSourceLabel(e.target.value)}
            />
          </FormInput>
          <FormInput label={'Auteur·ice'}>
            <InputText
              id="author"
              value={author}
              placeholder="Camille Laporte"
              onChange={(e) => setAuthor(e.target.value)}
            />
          </FormInput>
          <FormInput
            label={"Lien externe de l'article (URL)"}
            errorMessage={!validateURL(sourceUrl) && "L'URL doit commencer par http:// ou https://"}
            required
            isValid={sourceUrl && validateURL(sourceUrl)}>
            <InputText
              id="source_url"
              value={sourceUrl}
              placeholder="https://www.nouvelobs.com/topnews/20231022"
              onChange={(e) => setSourceUrl(e.target.value)}
              invalid={!validateURL(sourceUrl)}
            />
          </FormInput>
          <FormInput label={'Date de publication'} required isValid={publicationDate}>
            <Calendar
              id="publication-date"
              onChange={(e) => setPublicationDate(e.value)}
              dateFormat="dd/mm/yy"
              placeholder="Veuillez selectionner la date de publication"
              maxDate={new Date()}
              value={publicationDate}
              locale="fr"
            />
          </FormInput>
        </div>
        {footerButtons}
      </div>
    </Sidebar>
  );
}

export default NewsPanel;
